/** @format */

const template = `
<div class="white-layer" ng-class="{'d-none': !isEditMode}" edit-mode="false" white-layer-id="global-rootscope-editmode"></div>
`;
export default template;
